import { gql } from '@apollo/client';

export const getGeneralTransferPaymentDetails = gql`
query GetGeneralTransferPaymentDetails($id: String!, $input: GeneralTransferDetailsInput!) {
  getGeneralTransferPaymentDetails(id: $id, input: $input) {
    price
    customerFirstName
    customerLastName
    customerAddress
    customerCity
    customerZipCode
    customerCountry
    customerPhone
    customerEmail
    customerOib
    recipientName
    recipientAddress
    recipientCity
    recipientZipCode
    recipientAccountNumber
    referenceNumber
    referenceNumberType
    referencePrefix
    referenceSuffix
    model
    description
    numberOfInstallments
  }
}
`;